import * as types from "../types/campaigns";
import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  retrieveCommunicationChannels,
  retrieveEmails,
  retrieveEmailChannelCredits,
  retrieveEmailChannelStatistics,
  retrieveEmailChannelReputation,
  retrieveChannelSource,
  retrieveDistributionSelections,
  sendBulkEmails,
  authenticateDomain,
  validateDomain,
  deleteEmailChannelDomain,
  changeMailPlan,
  addNewEmailChannel,
  addNewSmsChannel,
  deleteEmailChannel,
  retrieveNumbersAvailable,
  purchaseNumber,
  deleteSmsChannelNumber,
  changeSmsPlan,
  sendBulkSms,
  retrieveSms,
} from "../../networking/campaigns/networking";

function* fetchCommunicationChannels(action) {
  try {
    if (action.payload) {
      const channels = yield call(
        retrieveCommunicationChannels,
        action.payload
      );
      if (channels.error === null) {
        yield put({
          type: types.SET_CAMPAIGNS_CHANNELS,
          content: channels.payload,
        });
      } else {
        throw new Error("Kunne ikke hente kanaler.");
      }
    } else {
      throw new Error("Kunne ikke hente kanaler.");
    }
  } catch (e) {
    yield put({
      type: types.REVOKE_CAMPAIGNS_CHANNELS,
      message: "Kunne ikke hente kanaler.",
    });
  }
}

function* fetchChannelCredits(action) {
  try {
    const details = yield call(retrieveEmailChannelCredits, action.details);
    if (details.error === null) {
      yield put({
        type: types.GRANT_SET_ACTIVE_CHANNEL_CREDITS,
        details: details.payload,
      });
    } else {
      throw new Error(details.error);
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SET_ACTIVE_CHANNEL_CREDITS, message: e });
  }
}

function* fetchEmailChannelStatistics(action) {
  try {
    const details = yield call(retrieveEmailChannelStatistics, action.details);
    if (details.error === null) {
      yield put({
        type: types.GRANT_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS,
        details: details.payload,
      });
    } else {
      throw new Error(details.error);
    }
  } catch (e) {
    yield put({
      type: types.REVOKE_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS,
      message: e,
    });
  }
}

function* fetchEmailChannelReputation(action) {
  try {
    const details = yield call(retrieveEmailChannelReputation, action.details);
    if (details.error === null) {
      yield put({
        type: types.GRANT_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION,
        details: details.payload,
      });
    } else {
      throw new Error(details.error);
    }
  } catch (e) {
    yield put({
      type: types.REVOKE_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION,
      message: e,
    });
  }
}

function* fetchChannelSource(action) {
  try {
    const details = yield call(retrieveChannelSource, action.details);
    if (details.error === null) {
      yield put({
        type: types.GRANT_SET_ACTIVE_CHANNEL_SOURCE,
        details: details.payload,
      });
    } else {
      throw new Error(details.error);
    }
  } catch (e) {
    const errMessage = e.toString().replace("Error:", "");
    yield put({
      type: types.REVOKE_SET_ACTIVE_CHANNEL_SOURCE,
      message: errMessage,
    });
  }
}

function* fetchEmailsList(action) {
  try {
    if (action.payload) {
      const campaigns = yield call(retrieveEmails, action.payload);
      if (campaigns.error === null) {
        yield put({
          type: types.SET_CHANNEL_EMAILS_CONTENT,
          content: campaigns.payload,
        });
      } else {
        throw new Error("Kunne ikke hente e-post.");
      }
    } else {
      throw new Error("Kunne ikke hente e-post.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_CHANNEL_EMAILS_CONTENT, message: e });
  }
}

function* performDeleteChannelDomain(action) {
  try {
    if (action.payload) {
      var response = yield call(deleteEmailChannelDomain, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_DELETE_EMAIL_CHANNEL_DOMAIN,
          details: response.payload,
        });
        yield put({
          type: types.CHANGE_CAMPAIGNS_MODALS,
          modal: { deleteDomainModal: false },
        });
      } else {
        throw new Error("Kunne ikke slette domene.");
      }
    } else {
      throw new Error("Kunne ikke slette domene.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DELETE_EMAIL_CHANNEL_DOMAIN, message: e });
    yield put({
      type: types.CHANGE_CAMPAIGNS_MODALS,
      modal: { deleteDomainModal: false },
    });
  }
}

function* fetchDistributionSelections(action) {
  try {
    if (action.payload) {
      var response = yield call(retrieveDistributionSelections, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_DISTRIBUTION_SELECTIONS,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke hente valg.");
      }
    } else {
      throw new Error("Kunne ikke hente valg.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DISTRIBUTION_SELECTIONS, message: e });
  }
}

function* performSendBulkEmails(action) {
  try {
    if (action.payload) {
      var response = yield call(sendBulkEmails, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_SEND_BULK_EMAILS,
          details: response.payload,
        });
        yield put({
          type: types.CHANGE_CAMPAIGNS_MODALS,
          modal: { distributeModal: false },
        });
      } else {
        throw new Error("Kunne ikke sende e-post.");
      }
    } else {
      throw new Error("Kunne ikke sende e-post.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SEND_BULK_EMAILS, message: e });
    yield put({
      type: types.CHANGE_CAMPAIGNS_MODALS,
      modal: { distributeModal: false },
    });
  }
}

function* performSendBulkSms(action) {
  try {
    if (action.payload) {
      var response = yield call(sendBulkSms, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_SEND_BULK_SMS,
          details: response.payload,
        });
        yield put({
          type: types.CHANGE_CAMPAIGNS_MODALS,
          modal: { distributeModal: false },
        });
      } else {
        throw new Error("Kunne ikke sende SMS.");
      }
    } else {
      throw new Error("Kunne ikke sende SMS.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SEND_BULK_SMS, message: e });
    yield put({
      type: types.CHANGE_CAMPAIGNS_MODALS,
      modal: { distributeModal: false },
    });
  }
}

function* performDomainAuthentication(action) {
  try {
    if (action.payload) {
      var response = yield call(authenticateDomain, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_DOMAIN_AUTHENTICATION,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke verifisere domenet.");
      }
    } else {
      throw new Error("Kunne ikke verifisere domenet.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DOMAIN_AUTHENTICATION, message: e });
  }
}

function* performDomainVerification(action) {
  try {
    if (action.payload) {
      var response = yield call(validateDomain, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_DOMAIN_VERIFICATION,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke verifisere domenet.");
      }
    } else {
      throw new Error("Kunne ikke verifisere domenet.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DOMAIN_VERIFICATION, message: e });
  }
}

function* performRequestMailPlanChange(action) {
  try {
    if (action.payload) {
      var response = yield call(changeMailPlan, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_MAIL_PLAN_CHANGE,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke oppgradere rekkevidde.");
      }
    } else {
      throw new Error("Kunne ikke oppgradere rekkevidde.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_MAIL_PLAN_CHANGE, message: e });
  }
}

function* performRequestNumberPurchase(action) {
  try {
    if (action.payload) {
      var response = yield call(purchaseNumber, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_PURCHASE_NUMBER,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke kjøpe nummer.");
      }
    } else {
      throw new Error("Kunne ikke kjøpe nummer.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_PURCHASE_NUMBER, message: e });
  }
}

function* performAddEmailChannel(action) {
  try {
    if (action.payload) {
      var response = yield call(addNewEmailChannel, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_ADD_EMAIL_CHANNEL,
          details: response.payload,
        });
        yield put({
          type: types.CHANGE_CAMPAIGNS_MODALS,
          modal: { newChannelModal: false },
        });
      } else {
        throw new Error("Kunne ikke legge til kanal.");
      }
    } else {
      throw new Error("Kunne ikke legge til kanal.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_ADD_EMAIL_CHANNEL, message: e });
    yield put({
      type: types.CHANGE_CAMPAIGNS_MODALS,
      modal: { newChannelModal: false },
    });
  }
}

function* performAddSmsChannel(action) {
  try {
    if (action.payload) {
      var response = yield call(addNewSmsChannel, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_ADD_SMS_CHANNEL,
          details: response.payload,
        });
        yield put({
          type: types.CHANGE_CAMPAIGNS_MODALS,
          modal: { newChannelModal: false },
        });
      } else {
        throw new Error("Kunne ikke legge til kanal.");
      }
    } else {
      throw new Error("Kunne ikke legge til kanal.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_ADD_SMS_CHANNEL, message: e });
    yield put({
      type: types.CHANGE_CAMPAIGNS_MODALS,
      modal: { newChannelModal: false },
    });
  }
}

function* performDeleteEmailChannel(action) {
  try {
    if (action.payload) {
      var response = yield call(deleteEmailChannel, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_DELETE_EMAIL_CHANNEL,
          details: response.payload,
        });
        yield put({
          type: types.CHANGE_CAMPAIGNS_MODALS,
          modal: { deleteChannelModal: false },
        });
      } else {
        throw new Error("Kunne ikke legge til kanal.");
      }
    } else {
      throw new Error("Kunne ikke legge til kanal.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DELETE_EMAIL_CHANNEL, message: e });
    yield put({
      type: types.CHANGE_CAMPAIGNS_MODALS,
      modal: { deleteChannelModal: false },
    });
  }
}

function* fetchNumbersAvailable(action) {
  try {
    if (action.payload) {
      var response = yield call(retrieveNumbersAvailable, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_NUMBERS_AVAILABLE,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke hente valg.");
      }
    } else {
      throw new Error("Kunne ikke hente valg.");
    }
  } catch (e) {
    const errMessage = e.toString().replace("Error:", "");
    yield put({ type: types.REVOKE_NUMBERS_AVAILABLE, message: errMessage });
  }
}

function* performDeleteChannelNumber(action) {
  try {
    if (action.payload) {
      var response = yield call(deleteSmsChannelNumber, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_DELETE_SMS_CHANNEL_NUMBER,
          details: response.payload,
        });
        yield put({
          type: types.CHANGE_CAMPAIGNS_MODALS,
          modal: { deleteNumberModal: false },
        });
      } else {
        throw new Error("Kunne ikke slette nummer.");
      }
    } else {
      throw new Error("Kunne ikke slette nummer.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DELETE_SMS_CHANNEL_NUMBER, message: e });
    yield put({
      type: types.CHANGE_CAMPAIGNS_MODALS,
      modal: { deleteNumberModal: false },
    });
  }
}

function* performRequestSmsPlanChange(action) {
  try {
    if (action.payload) {
      var response = yield call(changeSmsPlan, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_SMS_PLAN_CHANGE,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke oppgradere rekkevidde.");
      }
    } else {
      throw new Error("Kunne ikke oppgradere rekkevidde.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SMS_PLAN_CHANGE, message: e });
  }
}

function* fetchSmsList(action) {
  try {
    if (action.payload) {
      const campaigns = yield call(retrieveSms, action.payload);
      if (campaigns.error === null) {
        yield put({
          type: types.SET_CHANNEL_SMS_CONTENT,
          content: campaigns.payload,
        });
      } else {
        throw new Error("Kunne ikke hente SMS");
      }
    } else {
      throw new Error("Kunne ikke hente SMS.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_CHANNEL_SMS_CONTENT, message: e });
  }
}

function* campaignsSaga() {
  yield all([
    takeEvery(types.REQUEST_CAMPAIGNS_CHANNELS, fetchCommunicationChannels),
    takeEvery(types.REQUEST_SET_ACTIVE_CHANNEL_CREDITS, fetchChannelCredits),
    takeEvery(
      types.REQUEST_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS,
      fetchEmailChannelStatistics
    ),
    takeEvery(
      types.REQUEST_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION,
      fetchEmailChannelReputation
    ),
    takeEvery(types.REQUEST_SET_ACTIVE_CHANNEL_SOURCE, fetchChannelSource),
    takeEvery(
      types.REQUEST_DELETE_EMAIL_CHANNEL_DOMAIN,
      performDeleteChannelDomain
    ),
    takeEvery(types.REQUEST_CHANNEL_EMAILS_CONTENT, fetchEmailsList),
    takeEvery(
      types.REQUEST_DISTRIBUTION_SELECTIONS,
      fetchDistributionSelections
    ),
    takeEvery(types.REQUEST_SEND_BULK_EMAILS, performSendBulkEmails),
    takeEvery(types.REQUEST_SEND_BULK_SMS, performSendBulkSms),
    takeEvery(types.REQUEST_DOMAIN_AUTHENTICATION, performDomainAuthentication),
    takeEvery(types.REQUEST_DOMAIN_VERIFICATION, performDomainVerification),
    takeEvery(types.REQUEST_MAIL_PLAN_CHANGE, performRequestMailPlanChange),
    takeEvery(types.REQUEST_PURCHASE_NUMBER, performRequestNumberPurchase),
    takeEvery(types.REQUEST_ADD_EMAIL_CHANNEL, performAddEmailChannel),
    takeEvery(types.REQUEST_ADD_SMS_CHANNEL, performAddSmsChannel),
    takeEvery(types.REQUEST_DELETE_EMAIL_CHANNEL, performDeleteEmailChannel),
    takeEvery(types.REQUEST_NUMBERS_AVAILABLE, fetchNumbersAvailable),
    takeEvery(
      types.REQUEST_DELETE_SMS_CHANNEL_NUMBER,
      performDeleteChannelNumber
    ),
    takeEvery(types.REQUEST_SMS_PLAN_CHANGE, performRequestSmsPlanChange),
    takeEvery(types.REQUEST_CHANNEL_SMS_CONTENT, fetchSmsList),
  ]);
}

export default campaignsSaga;
